/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { getProp } from "@insite/mobius/utilities";
import { styledBox } from "@monsma/XDL/Components/Common/Box";
import { screen } from "@monsma/XDL/Helpers";
import Edit from "@monsma/XDL/Icons/Edit";
import { css } from "styled-components";

export const changeLink = {
    css: css`
        ${getProp("theme.link.defaultProps.css")};
        margin-left: 20px;
        align-self: center;
    `,
    icon: {
        iconProps: {
            src: Edit,
            color: "common.ui5",
            size: 12,
            css: css`
                margin-right: 5px;
            `,
        },
    },
};

export const addressWrapper = {
    css: css`
        ${styledBox};
        width: 50%;
        max-width: 314px;
        margin-top: 10px;

        ${screen("lt", "sm")} {
            width: 100%;
        }
    `,
};
